import styled from 'styled-components';
import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent
} from '../../../styles/helpers/flexbox';

const Wrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${flexDirection('column')};

  min-height: calc(100% - 192px);
  border: 1px solid ${colours.grey[400]};;
  background-color: ${colours.grey[200]};
`;
});

const Header = styled.header((props) => {
  const { colours } = props.theme;
  return `
        ${flexbox()};

        position: sticky;
        top: 192px;
        z-index: 1;
        width: 54px;
        height: 47px;
        min-height: 47px;
        background-color: ${colours.grey[400]};
        border-right: 1px solid ${colours.grey[500]};
        box-sizing: border-box;

        @media screen and (max-width: 1100px) {
          min-height: 37px;
          height: 37px;
          top: 0;
        }
`;
});

const CellContainer = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};
`;

const GridColumn = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
`;

export { Wrapper, Header, CellContainer, GridColumn };



// WEBPACK FOOTER //
// ./components/grid/collapsed/styled.js